import { render, staticRenderFns } from "./lawyer_detial.vue?vue&type=template&id=6628735a&scoped=true"
import script from "./lawyer_detial.vue?vue&type=script&lang=js"
export * from "./lawyer_detial.vue?vue&type=script&lang=js"
import style0 from "./lawyer_detial.vue?vue&type=style&index=0&id=6628735a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628735a",
  null
  
)

export default component.exports